import HotelOffer from '../ObjectValue/HotelOffer';

const HotelOffersRepository = Backbone.Collection.extend({
    model: HotelOffer,
});

export default HotelOffersRepository;
